<template>
  <div>
    <div>
      <van-popup class="modal" v-model="show" closeable close-icon="close">
        <div>
          <div>开票说明</div>
          <div>1、发票只能开具一个月内病案申请的发票；</div>
          <div>2、已经开具了纸质发票的记录不能再开具电子发票；</div>

          <div>
            3、开票失败的发票，可拨打病案通客服电
            话：400-136-3666，或到医院现场咨询办理；
          </div>
          <div>
            4、部分医院复印费发票暂时不支持开具电子发票，
            如需复印费发票请咨询医院现场工作人员
          </div>
        </div>
      </van-popup>
    </div>
    <div>
      <van-tabs v-model="active" color="#1aad19" @click="clickTab(active)" sticky>
        <van-tab title="可开票">
          <div v-if="showPersonal">
            <div class="van-ellipsis headline">
              <div>
              开票列表
              <span class="headlineTip">（请勾选需要的发票）</span>
              </div>
              <div class="invoice_shows" is-link @click="showPopup">
              <span>发票说明</span>
              </div>
            </div>
            <div v-if="availList.length == 0" class="noinfo">
              暂无可申请发票
            </div>
            <div v-if="availList.length != 0">
              <van-collapse v-model="activeNames">
                <van-collapse-item
                  v-for="(item, index) in availList"
                  :key="'invoice' + index"
                  :name="index"
                  class="collapse-item"
                >
                  <template #title>
                    <!--  @click="selectCollapse(index)" -->
                    <div class="title_text flexaround">
                      <div class="content" style="margin-left: 4px">
                        <div>申请编号：{{ item.requestId }}</div>
                        <div>患者姓名：{{ item.patientName }}</div>
                        <div>就诊医院：{{ item.hospitalName }}</div>

                        <div>
                          <div class="type">{{ item.businessTypeName }}</div>
                        </div>
                      </div>
                      <div class="openMoney">
                        <div class="canMoneyTip">可开票金额</div>
                        <div class="canMoney">
                          {{ item.invoiceFee }}
                          <span class="unit">元</span>
                        </div>
                        <div class="bill_fold">开票详情</div>
                      </div>
                    </div>
                  </template>
                  <!-- 内容 -->
                  <div>
                    <div class="costTitle">费用明细</div>
                    <!-- 数据 -->
                    <div
                      class="costinfo"
                      v-for="(subitem, index) in item.invoicePlats"
                      :key="'invoicePlats' + index"
                    >
                      <div>提供方：{{ subitem.platCustomName }}</div>
                      <!--  flexaround -->
                      <div class="data_cost title_text1">
                        <div class="checkitem">
                          <div
                            class="checkBox"
                            v-for="(sub1item, index) in subitem.invoiceFeeItems"
                            :key="'subitem' + index"
                          >
                            <!-- <van-checkbox v-model="checked" shape="square">复印费 30</van-checkbox> disabled="sub1item.isAllowSelect == 0" -->
                            <div class="checkNum">
                              <div class="checknameinfo">
                                <div>
                                <van-checkbox-group v-model="result">
                                <!--  @click="checkInfo(item.requestId,sub1item.feeParty)"  -->
                                <van-checkbox
                                  :disabled="sub1item.isAllowSelect == 0"
                                  :class="
                                    sub1item.isAllowSelect == 0
                                      ? 'through_line'
                                      : ''
                                  "
                                  shape="square"
                                  @click="
                                    checkInfo(item.requestId, sub1item.feeParty)
                                  "
                                  :name="
                                    item.requestId + ':' + sub1item.feeParty
                                  "
                                  >{{ sub1item.feeItem
                                  }}
                                  
                                  </van-checkbox
                                >
                              </van-checkbox-group>
                              </div>
                              
                              <div class="feeItemValue" :class="
                                    sub1item.isAllowSelect == 0
                                      ? 'through_line'
                                      : ''
                                  ">
                                {{
                                    sub1item.feeItemValue
                                  }} 
                                  <span class="unit">元</span>
                              </div>
                              </div>
                              
                            </div>

                            <!-- class="sub1item.isAllowSelect == 0?'through_line':''" -->
                            <!-- style="text-decoration: line-through" -->
                            <!--  class="checkTip" -->
                            <div class="checketipMsg">
                              {{ sub1item.tipMsg }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </van-collapse-item>
              </van-collapse>
            </div>
            <div class="gobill">
              <div v-if="availList.length != 0" class="billbutton" @click="billbutton">开具发票</div>
              <div>
                <!-- <div class="billtip" is-link @click="showPopup">发票说明</div> -->
              </div>
            </div>
          </div>
          <div v-if="!showPersonal">
            <div>
              <!-- 发票详情 -->
              <div>
                <div class="headline">发票详情</div>
                <ul class="bii_info">
                  <li class="bill_item">
                    <span class="colorGrey">发票类型</span>
                    <span>电子发票</span>
                  </li>
                  <li class="bill_item">
                    <span class="colorGrey">抬头类型</span>
                    <span>个人/非企业</span>
                  </li>
                  <li class="bill_item">
                    <span class="colorGrey">发票抬头</span>
                    <span>{{ availList[0].patientName }}</span>
                  </li>
                </ul>
              </div>
              <!-- 收件人信息 -->
              <div>
                <div class="headline">收件人详情</div>
                <ul class="bii_info">
                  <li class="bill_item">
                    <div class="phoneNumColor"><span class="colorGrey"
                      >手机号码
                      <span class="beDoing">(必填)</span>
                    </span></div>
                    <div>
                      <span
                      ><input
                        type="number"
                        class="input"
                        placeholder="请输入手机号码"
                        v-model="phoneNum"
                        style="text-align:right"
                    /></span>
                    </div>
                    
                    
                  </li>
                  <li class="bill_item">
                    <span class="colorGrey">邮箱地址</span>
                    <span
                      ><input
                        type="text"
                        class="input"
                        placeholder="请输入邮箱地址"
                        v-model="emailNum"
                        style="text-align:right"
                    /></span>
                  </li>
                </ul>
              </div>
              <div class="gobill">
                <div class="billbutton" @click="getinvoiceApply">
                  提交电子发票
                </div>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="可下载">
          <div>
            <!-- <div class="van-ellipsis headline">可下载列表</div> -->
            <div class="van-ellipsis headline">
              <div>
              可下载列表
              <!-- <span class="headlineTip">（请勾选需要的发票）</span> -->
              </div>
              <div class="invoice_shows" is-link @click="showPopup">
              <span>发票说明</span>
              </div>
            </div>
            <div v-if="invoiceList.length == 0" class="noinfo">
              暂无可下载发票
            </div>
            <div v-else-if="invoiceList.length != 0">
              <div
              
              class="downInfo collapse-item"
              v-for="(item, index) in invoiceList"
              :key="'invoiceList' + index"
              @click="downLoadUrl(item.invoiceUrl)"
            >
              <div class="title_text flexaround">
                <div class="content">
                  <div>申请编号：{{ item.requestId }}</div>
                  <div>患者姓名：{{ item.patientName }}</div>
                  <div>就诊医院：{{ item.hospitalName }}</div>

                  <div>
                    <div class="type">{{ item.businessTypeName }}</div>
                  </div>
                </div>
                <div class="openMoney">
                  <div class="costType">{{ item.feePartyName }}</div>
                  <div class="costNum">{{ item.invoiceFee }}
                    <span class="unit">元</span>
                    </div>
                </div>
              </div>
            </div>
            <div class="gobill">
              <div>
                <!-- <div class="billtip" is-link @click="showPopup">发票说明</div> -->
              </div>
            </div>
            </div>
            
          </div>
        </van-tab>
        <van-tab title="开票中">
          <div>
            <!-- <div class="van-ellipsis headline">开票中列表</div> -->
            <div class="van-ellipsis headline">
              <div>
              开票中列表
              <!-- <span class="headlineTip">（请勾选需要的发票）</span> -->
              </div>
              <div class="invoice_shows" is-link @click="showPopup">
              <span>发票说明</span>
              </div>
            </div>
            <div v-if="invoiceList.length == 0" class="noinfo">
              <div>暂无开票中发票</div>
              <div>如已申请，请等待5分钟查看</div>
            </div>
            <div v-else-if="invoiceList.length != 0">
<div
              class="downInfo collapse-item"
              v-for="(item, index) in invoiceList"
              :key="'invoiceListing' + index"
            >
              <div class="title_text flexaround">
                <div class="content">
                  <div>申请编号：{{ item.requestId }}</div>
                  <div>患者姓名：{{ item.feePartyName }}</div>
                  <div>就诊医院：{{ item.hospitalName }}</div>

                  <div>
                    <div class="type">{{ item.businessTypeName }}</div>
                  </div>
                </div>
                <div class="openMoney">
                  <div class="costType">{{ item.feePartyName }}</div>
                  <div class="costNum">{{ item.invoiceFee }}
                    <span class="unit">元</span>
                    </div>
                  <div class="beDoing">开票中</div>
                </div>
              </div>
            </div>
            <div class="gobill">
              <div>
                <!-- <div class="billtip" is-link @click="showPopup">发票说明</div> -->
              </div>
            </div>
            </div>
            
          </div>
        </van-tab>
        <van-tab title="开票失败">
          <div>
            <!-- <div class="van-ellipsis headline">开票失败列表</div> -->
            <div class="van-ellipsis headline">
              <div>
              开票失败列表
              <!-- <span class="headlineTip">（请勾选需要的发票）</span> -->
              </div>
              <div class="invoice_shows" is-link @click="showPopup">
              <span>发票说明</span>
              </div>
            </div>
            <div v-if="invoiceList.length == 0" class="noinfo">
              暂无开票中发票
            </div>
            <div v-else-if="invoiceList.length != 0">
            <div
              class="downInfo collapse-item"
              v-for="(item, index) in invoiceList"
              :key="'invoiceListing' + index"
            >
              <div class="title_text flexaround">
                <div class="content">
                  <div>申请编号：{{ item.requestId }}</div>
                  <div>患者姓名：{{ item.feePartyName }}</div>
                  <div>就诊医院：{{ item.hospitalName }}</div>

                  <div>
                    <div class="type">{{ item.businessTypeName }}</div>
                  </div>
                </div>
                <div class="openMoney">
                  <div class="costType">{{ item.feePartyName }}</div>
                  <div class="costNum">{{ item.invoiceFee }}
                    <span class="unit">元</span>
                    </div>
                  <div class="beDoing">开票失败</div>
                </div>
              </div>
            </div>
            <div class="gobill">
              <div>
                <!-- <div class="billtip" is-link @click="showPopup">发票说明</div> -->
              </div>
            </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
// let availList;
import Vue from "vue";
import {
  Tab,
  Tabs,
  Collapse,
  CollapseItem,
  Checkbox,
  CheckboxGroup,
  Popup,
  Notify,
} from "vant";

Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Popup);
Vue.use(Notify);
export default {
  data() {
    return {
      active: 0,
      activeNames: ["1"],
      // checked: false,
      showPersonal: true,
      show: false,
      availList: [],
      invoicePlats: [],
      result: [],
      phoneNum: "",
      emailNum: "",
      invoiceList: [],
    };
  },
  created() {
    const params = {
      userId: localStorage.getItem("userId"),
      ignorePeriod:localStorage.getItem("ignorePeriod"),
      // otherHosId: hosId,
    };
    this.getAvailable(params);
  },
  methods: {
    selectCollapse(index) {
      console.log(index);
      console.log("index");
      this.activeNames = [index];
      console.log(this.activeNames);
    },
    billbutton() {
      if (this.result == "") {
        Notify({
          type: "warning",
          message: "请选择要开具的发票",
        });
      } else {
        this.showPersonal = false;
        console.log(this.result);
        localStorage.setItem("selectTag", this.result);
        console.log(typeof this.result);
      }
    },
    showPopup() {
      this.show = true;
    },
    getAvailable(params) {
      // let that = this;
      this.$server.getAvailable(params).then((res) => {
        if (res.result == 1) {
          console.log("发票");
          this.availList = res.availList;
          // this.invoicePlats = res.availList.invoicePlats
          console.log(this.availList);
        }
      });
    },
    checkInfo(requestId, feeParty) {
      console.log(requestId, feeParty);
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    submitApply() {
      console.log(this.phoneNum);
      console.log(this.emailNum);
    },
    getinvoiceApply() {
      if (this.phoneNum == "") {
        Notify({
          type: "warning",
          message: "请输入手机号码",
        });
        return;
      }
      let reg = /^1[0-9]{10}$/.test(this.phoneNum);
      if (reg == false) {
        Notify({
          type: "warning",
          message: "请输入正确的手机号码",
        });
        return;
      } 
      let str = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(this.emailNum);
      console.log(str)
      console.log(this.emailNum)
      if(this.emailNum != '' && str == false){
          Notify({
          type: "warning",
          message: "请输入正确的填写邮箱",
        });
        return;
      }
      // if(str){
        
      // }
      else {
        // let result = Array.from(this.result)
        const params = {
          userId: localStorage.getItem("userId"),
          tel: this.phoneNum,
          email:this.emailNum,
          userName: this.availList[0].patientName,
          items: this.result.toString(),
          // otherHosId: hosId,
        };
        // let that = this;
        this.$server.getinvoiceApp(params).then((res) => {
          if (res.result == 1) {
            console.log("开启发票请求");
            this.showPersonal = true;
            this.result = [];
            this.activeNames = [];
            this.phoneNum = "";
            this.emailNum = "";
            this.active = 2;
            this.clickTab(2);
            // this.availList = res.availList;
            // this.invoicePlats = res.availList.invoicePlats
            // console.log(this.availList);
          }
        });
      }
    },
    clickTab(active) {
      console.log(active);
      var voucherStatus = 0;
      // if (active == 1) {
      //     voucherStatus= 2,
      // }
      // if (active == 2) {
      //     voucherStatus=1,
      // }
      // if(active == 3) {
      //     voucherStatus= 99,
      // }
      if (active == 0) {
        //   console.log(active)
        //   const params = {
        //   userId: localStorage.getItem("userId"),
        // // otherHosId: hosId,
        //   };
        //   this.getAvailable(params);
        const params = {
        userId: localStorage.getItem("userId"),
        ignorePeriod:localStorage.getItem("ignorePeriod"),
          // otherHosId: hosId,
        };
        this.getAvailable(params);

      } else {
        this.activeNames = [];
        if (active == 1) {
          voucherStatus = 2;
          
        }
        if (active == 2) {
          voucherStatus = 1;
          console.log('voucherStatus为1')
        }
        if (active == 3) {
          voucherStatus = 99;
        }
        const params = {
          userId: localStorage.getItem("userId"),
          voucherStatus: voucherStatus,
          // otherHosId: hosId,
        };
        this.$server.getinvoiceLi(params).then((res) => {
          if (res.result == 1) {
            console.log("开启发票请求");
            // this.availList = res.availList;
            console.log(res);
            this.invoiceList = res.invoiceList;
            // this.invoicePlats = res.availList.invoicePlats
            // console.log(this.availList);
          }
        });
      }
    },
    downLoadUrl(invoiceUrl) {
      console.log(invoiceUrl);
      window.open(invoiceUrl, "_blank");
    },
  },
};
</script>

<style>
.modal {
  width: 80%;
  padding: 20px;
}
.explain {
  background: white;
  width: 100%;
  /* v-height: 100%; */
}
.title_text {
  display: flex;
  flex-direction: row;
  background: white;
}
.title_text1 {
  display: flex;
  flex-direction: column;
  background: white;
}
.flexaround {
  justify-content: space-around;
}
.flexbetween {
  justify-content: space-between;
}
.noinfo{
  text-align: center;
  margin-top: 60px;
}
.collapse-item{
  margin-bottom: 10px;
}
.invoice_shows{
  font-size: 14px;
  color: #1aad19;
  text-align: right;
}
.content {
  flex: 8;
  text-align: left;
}
.headline {
  line-height: 40px;
  margin-left: 20px;
  display: flex;
  justify-content: space-between;
  margin-right: 20px;
}
.headlineTip {
  font-size: 13px;
  color: #999999;
}
.openMoney {
  flex: 4;
  text-align: right;
  text-align: center;
}
.canMoneyTip{
  margin-top: 6px;
}
.canMoney {
  font-size: 30px;
  font-weight: 500;
  margin-top: 6px;
  padding-bottom: 6px;
}
.costTitle {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 15px;
}
.costinfo {
  color: #333333;
  line-height: 10px;
  margin-top: 10px;
}
.costType {
  color: #333333;
  font-size: 14px;
  font-weight: 500;
  margin-top: 10px;
}
.costNum {
  color: #333333;
  font-size: 30px;
  font-weight: 500;
  margin: 5px 0;
  /* margin-top: 20px; */
}
.checkBox {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
}
.checkitem {
  display: flex;
  flex-direction: column;
  padding-bottom: 20rpx;
}
.checkNum {
  flex: 6;
  display: flex;
}
.checkTip {
  flex: 6;
  line-height: 18px;
  color: #999999;
  font-size: 12px;
}
.type {
  border-radius: 5px;
  border: 1px solid #1aad19;
  display: inline;
  color: #1aad19;
  padding: 2px 10px;
}
.bill_fold {
  color: #1aad19;
}
.data_cost {
  border-bottom: 1px solid #f1f1f1;
  padding: 10px;
}
.gobill {
  text-align: center;
  border-radius: 10px;
  margin-top: 40px;
}
.billbutton {
  text-align: center;
  color: white;
  /* padding: 10px 40px; */
  background: #1aad19;
  /* display: inline; */
  /* line-height: 124px; */
  line-height: 45px;
  height: 45px;
  width: 100%;
  position: fixed;
  bottom: 0;
  /* border-radius: 6px; */
}
.billtip {
  color: #1aad19;
  margin-top: 30px;
}
.bii_info {
  background: white;
  padding: 10px 20px;
  line-height: 34px;
  font-size: 15px;
  margin-bottom: 40px;
}
.downInfo {
  /* margin: 10px 15px; */
  padding: 10px 20px;
  background: white;
  font-size: 14px;
  line-height: 24px;
  border-bottom: 1px solid #f1f1f1;
}
.bill_item {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.beDoing {
  color: red;
}
.phoneNumColor{
  display: flex;
  flex:6;
  color:red
}
.colorGrey {
  color: #666666;
}
.colorblack {
  color: #333333;
}
.input {
  border: none;
  color: #333333;
  /* text-align: left; */
}
input::-webkit-input-placeholder {
  color: #aaaaaa;
  font-size: 14px;
  /* text-align: left; */
  /* color: #333333; */
}
.through_line {
  text-decoration: line-through;
  color: #aaaaaa;
}
.unit{
  font-size: 14px;
}
.feeItemValue{
  line-height: 20px;
  text-align: right;
  font-weight: 500;
}
.checketipMsg{
  flex: 6;
  line-height: 20px;
}
.checknameinfo{
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-right: 10px;
  font-size: 15px;
}
</style>